import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const buildUrl = (path: string) => {
  if (API_BASE_URL) {
    return `${API_BASE_URL.replace(/\/$/, '')}${path}`
  }
  return path
}

export interface CompanyDto {
  companyId: string
  tenantId: string
  code: string
  name: string
  type: string
  taxId?: string | null
  phone?: string | null
  email?: string | null
  isActive: boolean
  createdAt: string
}

export type CompanyStatusFilter = 'all' | 'active' | 'inactive'

export interface CompanyUpsertRequest {
  tenantId: string
  code: string
  name: string
  type: string
  taxId?: string
  phone?: string
  email?: string
  isActive: boolean
}

export interface PagedResultDto<T> {
  items: T[]
  pageNumber: number
  pageSize: number
  totalItems: number
  totalPages: number
}

interface SearchCompaniesParams {
  tenantId: string
  search?: string
  status?: CompanyStatusFilter
  page?: number
  pageSize?: number
}

export async function searchCompanies({
  tenantId,
  search,
  status = 'all',
  page = 1,
  pageSize = 20,
}: SearchCompaniesParams): Promise<PagedResultDto<CompanyDto>> {
  const response = await axios.get<PagedResultDto<CompanyDto>>(buildUrl('/api/v1/companies'), {
    params: {
      tenantId,
      search,
      status,
      page,
      pageSize,
    },
  })
  return response.data
}

export async function createCompany(payload: CompanyUpsertRequest): Promise<CompanyDto> {
  const response = await axios.post<CompanyDto>(buildUrl('/api/v1/companies'), payload)
  return response.data
}

export async function updateCompany(companyId: string, payload: CompanyUpsertRequest): Promise<CompanyDto> {
  const response = await axios.post<CompanyDto>(buildUrl(`/api/v1/companies/${companyId}`), payload)
  return response.data
}

export async function deleteCompany(companyId: string, tenantId: string): Promise<void> {
  await axios.delete(buildUrl(`/api/v1/companies/${companyId}`), {
    params: { tenantId },
  })
}
